export enum newOrderDurationIdentifier {
  WITHIN_2_MINS = 1,
  WITHIN_4_MINS,
  WITHIN_6_MINS,
  OVERDUE
}
